import React from 'react'
import { Element, ElementProps, baseStyles } from '@theme-components/utils'
import * as Reach from '@reach/dialog'

export type DialogOverlayProps = ElementProps & Reach.DialogProps

export const DialogOverlay: React.FC<DialogOverlayProps> = ({ ...props }) => {
  return (
    <Element
      __css={baseStyles.overlay}
      __themeKey="overlays"
      variant="default"
      as={Reach.DialogOverlay}
      {...props}
    />
  )
}

export type DialogContentProps = ElementProps & Reach.DialogContentProps

export const DialogContent: React.FC<DialogContentProps> = ({ ...props }) => {
  return (
    <Element
      __css={baseStyles.dialog}
      __themeKey="dialogs"
      variant="default"
      as={Reach.DialogContent}
      {...props}
    />
  )
}

export type DialogProps = ElementProps & Reach.DialogProps

export const Dialog: React.FC<DialogProps> = ({ children, ...props }) => {
  return (
    <DialogOverlay {...props}>
      <DialogContent>{children}</DialogContent>
    </DialogOverlay>
  )
}
